var _style, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoSetaBaixo01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 36 36",
    style: {
      enableBackground: "new 0 0 36 36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#040405;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "ico-seta-cima-2_1_",
    className: "st0",
    d: "M4.6,6.8L18,20.6L31.4,6.8l4.1,4.2L18,29.2L0.5,11.1L4.6,6.8z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoSetaBaixo01);
export default __webpack_public_path__ + "static/media/ico-seta-baixo-01.1d23ac694dfeabe7cb6c667d9f463146.svg";
export { ForwardRef as ReactComponent };